// Copyright 2024 - MinIO, Inc. All rights reserved.

export const findUrlParts = (data: string[], keys: string[]): string[] => {
  let result: string[] = [];
  for (let i = 0; i < data.length - 1; i++) {
    if (keys.includes(data[i])) {
      result.push(data[i + 1]);
    }
  }
  return result;
};
